document.addEventListener('DOMContentLoaded', () => {
    const articleContent = document.querySelector('.article__content');
    const articleToc = document.querySelector('.article-toc');

    if (!articleContent || !articleToc) {
        return;
    }

    const tocLinks = document.querySelectorAll('[data-toc-link]');
    const headings = document.querySelectorAll('.article__content h2, .article__content h3');
    
    // Helper function to check if element is in viewport
    const isInViewport = (element) => {
        const rect = element.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.top <= (window.innerHeight || document.documentElement.clientHeight) / 2
        );
    };

    // Update active TOC link
    const updateToc = () => {
        let currentHeading = null;
        
        // If we're at the top of the article content, scroll TOC to top
        if (articleContent.getBoundingClientRect().top >= 0) {
            articleToc.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
            return;
        }
        
        // Find the first heading that's in viewport
        headings.forEach(heading => {
            if (isInViewport(heading) && !currentHeading) {
                currentHeading = heading;
            }
        });

        tocLinks.forEach(link => link.classList.remove('active'));
        
        if (currentHeading) {
            const currentLink = document.querySelector(`[data-toc-link][href="#${currentHeading.id}"]`);
            if (currentLink) {
                currentLink.classList.add('active');
                articleToc.scrollTo({
                    top: currentLink.offsetTop,
                    behavior: 'smooth'
                });
            }
        }
    };

    window.addEventListener('scroll', () => {
        setTimeout(updateToc, 1000);
    });

    updateToc();
});